export default "__VITE_ASSET__BACo$9r7__"